<template>
  <div class="groups">
    <h1>{{ $t('organizations.groups') }}</h1>
    <users-table
      :data="tableData"
    />
  </div>
</template>

<script>
  import UsersTable from '@/components/common/UsersTable'

  export default {
    components: {
      UsersTable
    },
    data() {
      return {
        tableData: [{
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }, {
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }, {
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }, {
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }, {
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }, {
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }, {
          avatar: 'avatar.png',
          email: 'useremail@email.com',
          username: 'Name Lastname',
          titleDep: 'Coordinator, Delivery',
          roles: ['Student', 'Teacher']
        }],
        multipleSelection: []
      }
    }
  }
</script>

<style lang="scss" scoped>
  table {
    width: 100% !important;
  }

</style>
